import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)
export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: "/",
            redirect: './home',
        },

        // 首页
        {
            path: '/home',
            name: "/home",
            component: () => import('./components/Home.vue'),
            
        },
        // { 
        //     path: '/outer',
        //     name: "/outer",
        //     component: () => import('./components/Outer.vue'),
        //     children: [
        //         // 开户
        //         { 
        //             path: '/openAccount',
        //             name: "/openAccount",
        //             component: () => import('./components/OpenAccount.vue'),
        //         }, 
        //     ]
        // }, 
        // 关于雅格
        {
            path: '/aboutyage',
            name: "/aboutyage",
            component: () => import('./components/Aboutyage.vue'),
            
        },
        // 搜索页面
        {
            path: '/search',
            name: "/search",
            component: () => import('./components/Search.vue'),
           
        },
        // 产品与解决方案
        {
            path: '/productAndsolve',
            name: "/productAndsolve",
            component: () => import('./components/Product.vue'),
           
        },
        // 数据可视化
        {
            path: '/visual',
            name: "visual",
            component: () => import('./components/Visual.vue'),
        },
        // RPA解决方案
        {
            path: '/RPA',
            name: "RPA",
            component: () => import('./components/RPAscheme.vue'),
            
        },
         // BI大数据解决方案
         {
            path: '/BI',
            name: "BI",
            component: () => import('./components/BI.vue'),
            
        },
        // 智能银行解决方案
        {
            path: '/bank',
            name: "bank",
            component: () => import('./components/Bankscheme.vue'),
            
        },
        // 智能风控解决方案
        {
            path: '/risk',
            name: "risk",
            component: () => import('./components/Riskscheme.vue'),
            
        },
        // 咨询服务

        // 新闻动态
        {
            path: '/news',
            name: "/news",
            component: () => import('./components/News.vue'),
            
        },
        // 新闻详情页
        {
            path: '/newsdetail',
            name: "/newsdetail",
            component: () => import('./components/NewsDetail.vue'),
            
        },
        // 联系我们
        // it服务
         // 加入雅格
         {
            path: '/it',
            name: "/it",
            component: () => import('./components/IT.vue'),
           
        },
        // 加入雅格
        {
            path: '/jionYG',
            name: "/jionYG",
            component: () => import('./components/JoinYage.vue'),
           
        },
    ]
})

// 以下代码解决路由地址重复的报错问题(一劳永逸)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
} 
